<template>
	<div class="space-y-4 mt-4">
		<div class="flex items-center w-full" v-for="(user, n) in users || []" :key="n">
			<div class="mr-2">
				<church-icon v-if="!user?.avatar && !user?.user_profile" class="!w-6 !h-6" icon="person-circle-fill"></church-icon>
				<img v-else class="w-6 h-6 object-fit rounded-full overflow-clip border border-white"
					:src="Array.isArray(user?.avatar) && user?.avatar[0] || Array.isArray(user?.avatar || user?.user_profile) && user?.user_profile[0] || user?.user_profile ||  user?.avatar || ''" alt="">
			</div>
			<div class="flex-1">
				{{ UserUtils.getFullName(user) || '' }}
			</div>

			<button v-if="editMode" @click="() => (toRemoveUsers = user, showDeleteGoalPop = true)">
				<church-icon class="!text-red !w-5 !h-5" icon="x-mark"></church-icon>
			</button>
		</div>

		<m-delete-confirmation-pop 
			title="Remove User" 
			:description="`Are you sure you want to remove ${UserUtils.getFullName(toRemoveUsers)}?`" 
			:showPop="showDeleteGoalPop" 
			@close="() => showDeleteGoalPop = false" 
			@continueDelete="() => (emit('removeUser', toRemoveUsers), showDeleteGoalPop = false)"
		/>
        
	</div>
</template>

<script setup >
/* ======= UTILS ===== */
import UserUtils from '@/helpers/userUtils';
import { defineProps, defineEmits, ref } from 'vue';

/* ========= PROPS ======= */
defineProps(
	{ 
		users:  {type: Array, default: () => []},
		editMode: {type: Boolean, default: false}
	}
)

/* =========== STATES ======== */
const toRemoveUsers = ref([])
const showDeleteGoalPop = ref(false)

/* =========== EMITS ======== */
const emit = defineEmits(['removeUser'])
</script>
